// AUTO-GENERATED from '3. ADW_TW_Forest-Drop-out-2025-2026.xlsx'
const DROPOUT_METRICS = {
  "state": {
    "total": {
      "boys": 327,
      "girls": 190,
      "total": 517
    },
    "adw": {
      "boys": 134,
      "girls": 85,
      "total": 219
    },
    "tw": {
      "boys": 176,
      "girls": 78,
      "total": 254
    },
    "forest": {
      "boys": 17,
      "girls": 27,
      "total": 44
    }
  },
  "districts": {
    "CUDDALORE": {
      "total": {
        "boys": 13,
        "girls": 6,
        "total": 19
      },
      "adw": {
        "boys": 13,
        "girls": 6,
        "total": 19
      },
      "tw": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "TIRUVANNAMALAI": {
      "total": {
        "boys": 75,
        "girls": 45,
        "total": 120
      },
      "adw": {
        "boys": 5,
        "girls": 2,
        "total": 7
      },
      "tw": {
        "boys": 54,
        "girls": 19,
        "total": 73
      },
      "forest": {
        "boys": 16,
        "girls": 24,
        "total": 40
      }
    },
    "TIRUPPUR": {
      "total": {
        "boys": 7,
        "girls": 11,
        "total": 18
      },
      "adw": {
        "boys": 5,
        "girls": 8,
        "total": 13
      },
      "tw": {
        "boys": 2,
        "girls": 3,
        "total": 5
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "THE NILGIRIS": {
      "total": {
        "boys": 23,
        "girls": 18,
        "total": 41
      },
      "adw": {
        "boys": 0,
        "girls": 1,
        "total": 1
      },
      "tw": {
        "boys": 23,
        "girls": 17,
        "total": 40
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "TIRUPATHUR": {
      "total": {
        "boys": 1,
        "girls": 4,
        "total": 5
      },
      "adw": {
        "boys": 0,
        "girls": 1,
        "total": 1
      },
      "tw": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "forest": {
        "boys": 1,
        "girls": 3,
        "total": 4
      }
    },
    "KALLAKURICHI": {
      "total": {
        "boys": 5,
        "girls": 3,
        "total": 8
      },
      "adw": {
        "boys": 3,
        "girls": 2,
        "total": 5
      },
      "tw": {
        "boys": 2,
        "girls": 1,
        "total": 3
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "VILLUPURAM": {
      "total": {
        "boys": 6,
        "girls": 6,
        "total": 12
      },
      "adw": {
        "boys": 2,
        "girls": 4,
        "total": 6
      },
      "tw": {
        "boys": 4,
        "girls": 2,
        "total": 6
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "ERODE": {
      "total": {
        "boys": 7,
        "girls": 4,
        "total": 11
      },
      "adw": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "tw": {
        "boys": 7,
        "girls": 4,
        "total": 11
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "NAMAKKAL": {
      "total": {
        "boys": 21,
        "girls": 7,
        "total": 28
      },
      "adw": {
        "boys": 5,
        "girls": 2,
        "total": 7
      },
      "tw": {
        "boys": 16,
        "girls": 5,
        "total": 21
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "KANCHEEPURAM": {
      "total": {
        "boys": 11,
        "girls": 2,
        "total": 13
      },
      "adw": {
        "boys": 11,
        "girls": 2,
        "total": 13
      },
      "tw": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "TIRUVALLUR": {
      "total": {
        "boys": 4,
        "girls": 5,
        "total": 9
      },
      "adw": {
        "boys": 4,
        "girls": 5,
        "total": 9
      },
      "tw": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "TIRUVARUR": {
      "total": {
        "boys": 7,
        "girls": 7,
        "total": 14
      },
      "adw": {
        "boys": 7,
        "girls": 7,
        "total": 14
      },
      "tw": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "SALEM": {
      "total": {
        "boys": 42,
        "girls": 20,
        "total": 62
      },
      "adw": {
        "boys": 2,
        "girls": 1,
        "total": 3
      },
      "tw": {
        "boys": 40,
        "girls": 19,
        "total": 59
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "TIRUCHIRAPPALLI": {
      "total": {
        "boys": 25,
        "girls": 15,
        "total": 40
      },
      "adw": {
        "boys": 25,
        "girls": 15,
        "total": 40
      },
      "tw": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "PUDUKKOTTAI": {
      "total": {
        "boys": 2,
        "girls": 2,
        "total": 4
      },
      "adw": {
        "boys": 2,
        "girls": 2,
        "total": 4
      },
      "tw": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "MAYILADUTHURAI": {
      "total": {
        "boys": 5,
        "girls": 0,
        "total": 5
      },
      "adw": {
        "boys": 5,
        "girls": 0,
        "total": 5
      },
      "tw": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "NAGAPATTINAM": {
      "total": {
        "boys": 2,
        "girls": 2,
        "total": 4
      },
      "adw": {
        "boys": 2,
        "girls": 2,
        "total": 4
      },
      "tw": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "VIRUDHUNAGAR": {
      "total": {
        "boys": 1,
        "girls": 0,
        "total": 1
      },
      "adw": {
        "boys": 1,
        "girls": 0,
        "total": 1
      },
      "tw": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "DHARMAPURI": {
      "total": {
        "boys": 11,
        "girls": 6,
        "total": 17
      },
      "adw": {
        "boys": 0,
        "girls": 1,
        "total": 1
      },
      "tw": {
        "boys": 11,
        "girls": 5,
        "total": 16
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "RAMANATHAPURAM": {
      "total": {
        "boys": 1,
        "girls": 2,
        "total": 3
      },
      "adw": {
        "boys": 1,
        "girls": 2,
        "total": 3
      },
      "tw": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "VELLORE": {
      "total": {
        "boys": 7,
        "girls": 2,
        "total": 9
      },
      "adw": {
        "boys": 3,
        "girls": 1,
        "total": 4
      },
      "tw": {
        "boys": 4,
        "girls": 1,
        "total": 5
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "KARUR": {
      "total": {
        "boys": 8,
        "girls": 1,
        "total": 9
      },
      "adw": {
        "boys": 8,
        "girls": 1,
        "total": 9
      },
      "tw": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "DINDIGUL": {
      "total": {
        "boys": 1,
        "girls": 0,
        "total": 1
      },
      "adw": {
        "boys": 1,
        "girls": 0,
        "total": 1
      },
      "tw": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "MADURAI": {
      "total": {
        "boys": 9,
        "girls": 9,
        "total": 18
      },
      "adw": {
        "boys": 9,
        "girls": 9,
        "total": 18
      },
      "tw": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "RANIPET": {
      "total": {
        "boys": 0,
        "girls": 1,
        "total": 1
      },
      "adw": {
        "boys": 0,
        "girls": 1,
        "total": 1
      },
      "tw": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "CHENGALPATTU": {
      "total": {
        "boys": 18,
        "girls": 5,
        "total": 23
      },
      "adw": {
        "boys": 7,
        "girls": 4,
        "total": 11
      },
      "tw": {
        "boys": 11,
        "girls": 1,
        "total": 12
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "COIMBATORE": {
      "total": {
        "boys": 1,
        "girls": 0,
        "total": 1
      },
      "adw": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "tw": {
        "boys": 1,
        "girls": 0,
        "total": 1
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "CHENNAI": {
      "total": {
        "boys": 1,
        "girls": 2,
        "total": 3
      },
      "adw": {
        "boys": 1,
        "girls": 2,
        "total": 3
      },
      "tw": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "SIVAGANGAI": {
      "total": {
        "boys": 2,
        "girls": 0,
        "total": 2
      },
      "adw": {
        "boys": 2,
        "girls": 0,
        "total": 2
      },
      "tw": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "THOOTHUKKUDI": {
      "total": {
        "boys": 1,
        "girls": 0,
        "total": 1
      },
      "adw": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "tw": {
        "boys": 1,
        "girls": 0,
        "total": 1
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "TIRUNELVELI": {
      "total": {
        "boys": 2,
        "girls": 1,
        "total": 3
      },
      "adw": {
        "boys": 2,
        "girls": 1,
        "total": 3
      },
      "tw": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "THANJAVUR": {
      "total": {
        "boys": 3,
        "girls": 1,
        "total": 4
      },
      "adw": {
        "boys": 3,
        "girls": 1,
        "total": 4
      },
      "tw": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "KRISHNAGIRI": {
      "total": {
        "boys": 1,
        "girls": 0,
        "total": 1
      },
      "adw": {
        "boys": 1,
        "girls": 0,
        "total": 1
      },
      "tw": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "PERAMBALUR": {
      "total": {
        "boys": 1,
        "girls": 2,
        "total": 3
      },
      "adw": {
        "boys": 1,
        "girls": 1,
        "total": 2
      },
      "tw": {
        "boys": 0,
        "girls": 1,
        "total": 1
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "THENI": {
      "total": {
        "boys": 3,
        "girls": 0,
        "total": 3
      },
      "adw": {
        "boys": 3,
        "girls": 0,
        "total": 3
      },
      "tw": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    },
    "TENKASI": {
      "total": {
        "boys": 0,
        "girls": 1,
        "total": 1
      },
      "adw": {
        "boys": 0,
        "girls": 1,
        "total": 1
      },
      "tw": {
        "boys": 0,
        "girls": 0,
        "total": 0
      },
      "forest": {
        "boys": 0,
        "girls": 0,
        "total": 0
      }
    }
  }
};

export default DROPOUT_METRICS;
